// extracted by mini-css-extract-plugin
module.exports = {"panel":"WelcomePage_panel__XGVJ3"};